import React from 'react';
import { LaosMarketSection } from '../components/LaosMarketSection';
export function LaosMarketPage() {
  return <div className="pt-20" data-id="element-497">
      <LaosMarketSection data-id="element-498" />
    </div>;
}